import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';
import { renderConditionBlockViewOnly } from '../workflows/conditionsManagerWorkflow';
import { renderCellSnippetType } from '../components/snippetsGrid';
import dayjs from "dayjs";
import { InfoToolTip } from '../commonComponents/generalComponents';

const RuleStatsViewer = (props) => {
  const [actionSnippetInfo, setActionSnippetInfo] = useState(undefined)

  useEffect(() => {
    //console.log(props.rule)
    if (props.rule?.action.type == 'showSnippet' && props.rule?.action.snippetId > 0) {
      getSnippetInfo(props.rule.action.snippetId)
    }
  }, [props.rule])

  const getSnippetInfo = useCallback(async (snippetId) => {
    try {
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);

      //console.log(response.data)
      setActionSnippetInfo(response.data) 

    } catch (error) {
      console.log(error);
    }


  }
  ,[])

    const renderAction = (action) => {
      //console.log(action)
      if (action?.type === 'showStatic') {
        return  <div>
                  <div className='text-center'>Show image</div>
                  <div className='bg-slate-200 rounded p-4 w-[300px] h-[200px] flex justify-center'>
                    <div className='relative h-full' >
                      <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${action.imgB64}`} />
                    </div>
                  </div>
                </div>
      }
      else return <div className='flex flex-col items-center justify-center'>
                    <div className='text-center'>Redirect to element</div>
                    <div className='flex flex-row gap-x-2 items-center justify-center w-[300px] h-[200px] bg-slate-100 rounded'>
                      {renderCellSnippetType({value: actionSnippetInfo?.snippetTypeId})}
                      <div className='flex flex-col items-start text-sm'>
                        <div className='font-semibold'>{actionSnippetInfo?.snippetName}</div>
                        <div>{dayjs(actionSnippetInfo?.created).format('DD/MM/YYYY')}</div>
                      </div>
                    </div>

      </div>
    }

function formatNumber(value) {
  return new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
}

    return <div className='flex flex-row items-center gap-x-12 text-ccColorDarkTeal font-poppins'>
          <div>
            <div className='text-center'>Conditions</div>
            <div className=' bg-slate-100 rounded p-4 w-[440px] h-[200px] overflow-auto'>
              {props.isDefault ? <div></div>
                :
                <div className='flex flex-row items-center flex-wrap gap-2'>{props.rule && props.rule.conditionBlocks.map(b => renderConditionBlockViewOnly(b))}</div>
              }
            </div>
          </div>

        <div>{renderAction(props.rule?.action)}</div>

        <div>
          <div className='text-center'>Stats</div>
          <div className={`flex flex-col gap-y-2`}>
            <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
              <div>Opens</div>
              <div className='text-2xl font-semibold'>{props.stats?.totalOpens}</div>
            </div>
            <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
              <div>Clicks</div>
              <div className='text-2xl font-semibold'>{props.stats?.totalClicks}</div>
            </div>
            <div className='bg-ccColorOrange text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
              <div>CTO</div>
              <div className='text-2xl font-semibold'>{(props.stats?.totalClicks > 0 && props.stats?.totalOpens > 0) ? formatNumber(props.stats?.totalClicks / props.stats?.totalOpens * 100): 0}%</div>
            </div>
          </div>
        </div>


    </div>
}

export default function SnippetRuleBuilderReport(props) {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [stats, setStats] = useState(undefined)
    const [rules, setRules] = useState(undefined)
    const [defaultAction, setDefaultAction] = useState(undefined)
    const [nonActiveRules, setNonActiveRules] = useState({opens: 0, clicks: 0})

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetInfo(undefined)
        getSnippetStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/condManager/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setStats(data)
      getCountFromNonActiveRules(data)

    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)
      const settings = JSON.parse(data.snippetSettings)
      setRules(settings.rules)
      setDefaultAction(settings.default)
      //console.log(settings.default)

    } catch (error) {
      console.log(error);
    }
  }
  const getCountFromNonActiveRules = (stats) => {
    let totalOpens = 0
    let totalClicks = 0
    const hashes = [...stats.activeRulesHashes]
    hashes.splice(0,0,'default') //including the default in the count
    for (const hash of hashes) {
      const currentActiveRule = stats.ruleStats.find(rs => rs.codeHash === hash)
      totalOpens += currentActiveRule.totalOpens
      totalClicks += currentActiveRule.totalClicks
    }
    const result = {opens: stats.totalOpens - totalOpens, clicks: stats.totalClicks - totalClicks}
    setNonActiveRules(result)
  }


    return <div>
            <CcTitle>Condition Manager Report</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Total Views', value: stats?.totalOpens},
                                    {title: 'Total Clicks', value: stats?.totalClicks},
                                    {title: 'Number of rules', value: stats?.numActiveRules},
                                    {title: 'Most views', value: stats?.mostUsedActiveRuleOpens, footer: `in ${stats?.mostUsedActiveRuleName}`},
                                    ]} />
            </div>
            <div className='mt-4'>
                {stats?.activeRulesHashes.map((hash, index) => {
                    const currentRuleStats = stats.ruleStats.find(rs => rs.codeHash == hash)
                    const currentRule = rules?.find(r => r.codeStrHash == currentRuleStats.codeHash)
                    return <div>
                            <div className='mt-2 border rounded p-2'>        
                              <div className='text-xl font-poppins font-semibold text-ccColorDarkTeal'>Rule {index +1}</div>
                              <RuleStatsViewer stats={currentRuleStats} rule={currentRule} />
                            </div>
                            <div className='flex flex-row justify-center'>
                              <Iconify icon="maki:arrow" width={64} rotate={45} className='text-ccColorDarkTeal mt-2' />
                            </div>
                          </div>
                })}
            </div>
            
            <div className='mt-4 border rounded p-2'>        
              <div className='text-xl font-poppins font-semibold text-ccColorDarkTeal'>Default</div>
              <RuleStatsViewer stats={stats?.ruleStats.find(rs => rs.codeHash == 'default')} rule={defaultAction ? {action: defaultAction} : undefined} isDefault />     
            </div>

            {(nonActiveRules.opens > 0 || nonActiveRules.clicks > 0) &&
            <div className='mt-4 border rounded p-2'>
              <div className='flex flex-row items-center gap-x-1'>
                <div className='text-xl font-poppins font-semibold text-ccColorDarkTeal'>Other</div>
                <InfoToolTip 
                        placement='right'
                        headLine=''
                        message={<div className='flex flex-col'>Any rule that generated impressions prior to being edited or deleted is counted here</div>}
                  />

              </div>
              <div className='mt-2 flex flex-row items-center gap-x-2'>
                <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                  <div>Opens</div>
                  <div className='text-2xl font-semibold'>{nonActiveRules.opens}</div>
                </div>
                <div className='bg-ccColorTeal text-white font-poppins text-sm w-40 rounded pl-4 py-1'>
                  <div>Clicks</div>
                  <div className='text-2xl font-semibold'>{nonActiveRules.clicks}</div>
                </div>
              </div>
            </div>
            }
    </div>
}